import { handleApiRequest } from "../../hooks/callApi";

// Get all department
export const getAllTutorials = async () => {
  const res = await handleApiRequest(`/api/getTutorials`, "get");

  return res;
};
